
const openWindow = (url: string) => {
    const features = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600';
    window.open(url, 'targetWindow', features);
};

export const Atlassian = Object.freeze({
    link() {
        openWindow('/connect/atlassian/link');
    },
    unlink() {
        openWindow('/connect/atlassian/unlink');
    },
});
